import styles from "./Analysts.module.scss";
import { FC } from "react";
import { useAtomValue } from "jotai";
import { positiveState, negativeState, textColorState } from "@/lib/store";
import { withStockStamp } from "@/components/stock-stamp-hoc/StockStampHOC";
import { classNames } from "@/lib/utils";
import { Box, Chip } from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

interface PropsTypes {
    upgrades: number;
    downgrades: number;
    buy: number;
    hold: number;
    sell: number;
    overviewPage?: boolean;
}

const Analysts: FC<PropsTypes> = ({ upgrades, downgrades, buy, hold, sell, overviewPage }) => {
    const positive = useAtomValue(positiveState);
    const negative = useAtomValue(negativeState);
    const textColor = useAtomValue(textColorState);

    const CHIP_STYLES = {
        width: "fit-content",
        fontWeight: "600",
        borderWidth: "2px",
        "@media screen and (min-width: 1280px)": {
            fontSize: "8px",
            "& .MuiChip-label": {
                padding: "0 4px",
            },
        },
        "@media screen and (min-width: 1920px)": {
            fontSize: "10px",
            "& .MuiChip-label": {
                padding: "6px",
            },
        },
    };

    return (
        <div className={classNames(styles.Analysts, styles[overviewPage && "overview-page"])}>
            <Box className={styles["chip-container"]} sx={overviewPage ? { flexDirection: "row", marginLeft: 0, flexWrap: "wrap" } : { flexDirection: "column" }}>
                <Chip className={overviewPage && styles.chip} clickable label={`${buy} BUY`} variant="outlined" color="primary" sx={{ ...CHIP_STYLES }} size="small" />
                <Chip className={overviewPage && styles.chip} clickable label={`${sell} SELL`} variant="outlined" color="error" sx={{ ...CHIP_STYLES }} size="small" />
                <Chip className={overviewPage && styles.chip} clickable label={`${hold} HOLD`} variant="outlined" color="error" sx={{ ...CHIP_STYLES, color: textColor, borderColor: textColor }} size="small" />
            </Box>

            <div className={styles.analystChanges}>
                <p style={{ marginBottom: overviewPage && "0px" }}>Analyst Changes (5D)</p>
                <div>
                    <div>
                        <span className="negative">{downgrades}</span>
                        <ArrowDownwardIcon className={styles.arrow} sx={{ color: negative }} />
                    </div>
                    <div>
                        <span className="positive">{upgrades}</span>
                        <ArrowUpwardIcon className={styles.arrow} sx={{ color: positive }} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withStockStamp(Analysts, "buy", { title: "Current Analyst View" }, "Analysts");
